import React from 'react';
import PropTypes from 'prop-types';
import { lazyProps } from '@unisporkal/react-lazy-component';
import { SiteProvider } from '@unisporkal/sites';
import { LocalizationProvider } from '@unisporkal/localization';
import { BoardToolboxProvider } from '@unisporkal/board-toolbox';
import { ThemeProvider as DeprecatedThemeProvider } from '@unisporkal/themes';
import { UserProvider } from '@unisporkal/user';
import { ExperiencesProvider } from '@unisporkal/experiences';
import { ThemeProvider } from '@unisporkal/alliance-ui';
import AttrTracking from './AttrTracking.tsx';

const Translations = lazyProps((props) =>
  import(`locales/${props.site}/${props.locale}.yml`)
);

const Providers = ({ children, user, experiences = {}, site, routing }) => (
  <UserProvider user={user}>
    <ExperiencesProvider experiences={experiences}>
      {/* Outside Translations: the scope element must exist before the
          visibility observer runs, and Translations renders nothing until
          its lazy locale import resolves. */}
      <AttrTracking>
        <Translations
          site={site.nickname}
          locale={user.locale}
        >
          {(translations) => (
            <LocalizationProvider
              translations={translations}
              locale={user.locale}
            >
              <SiteProvider
                nickname={site.nickname}
                host={routing.host}
                countryLanguagePrefix={routing.countryLanguagePrefix}
              >
                <ThemeProvider theme={site.nickname}>
                  <DeprecatedThemeProvider theme={site.nickname}>
                    <BoardToolboxProvider>{children}</BoardToolboxProvider>
                  </DeprecatedThemeProvider>
                </ThemeProvider>
              </SiteProvider>
            </LocalizationProvider>
          )}
        </Translations>
      </AttrTracking>
    </ExperiencesProvider>
  </UserProvider>
);

Providers.propTypes = {
  children: PropTypes.node.isRequired,
  user: PropTypes.shape({
    locale: PropTypes.string.isRequired,
  }).isRequired,
  experiences: PropTypes.shape({}),
  site: PropTypes.shape({
    nickname: PropTypes.string.isRequired,
  }).isRequired,
  routing: PropTypes.shape({
    countryLanguagePrefix: PropTypes.string,
    host: PropTypes.string,
  }).isRequired,
};

export default Providers;
